import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { SLICE_NAMESPACE } from '../../constants';
import { INavigationState } from '../../types';

export const fetchNavigationTrees = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchNavigationTrees`,
  async (_, { getState }) => {
    const {
      navigation: {
        navigationList: {
          query,
          pagination: { currentPage },
        },
      },
    } = getState();
    return apiService.navigation.getNavigationTrees({ page: currentPage, name: query });
  },
);

export const fetchNavigationTreesReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(fetchNavigationTrees.pending, state => {
      state.navigationList.loading.default = true;
      state.navigationList.trees = [];
    })
    .addCase(fetchNavigationTrees.rejected, state => {
      state.navigationList.loading.default = false;
      state.navigationList.trees = [];
    })
    .addCase(fetchNavigationTrees.fulfilled, (state, action) => {
      state.navigationList.loading.default = false;
      state.navigationList.trees = action.payload.trees;
      state.navigationList.pagination = action.payload.pagination;
    });
